import styled from 'styled-components';

import { pxToRem } from '@utils/converters';

export const MobileActions = styled.div({
  width: '100%',
  padding: `0 ${pxToRem(24)}`,
});
